// extracted by mini-css-extract-plugin
module.exports = {"root":"_3lI6sX4","container":"_3AWxZfU","title":"_9bx6tRq","logo":"_1u6Yco3"};